import MyRequests from "../../Components/LeaveMangmentComponent/MyRequests";


export const LeaveMangment = () => {
  return <MyRequests />;
};
